import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { checkAuth } from './auth';
import CircularProgress from '@mui/material/CircularProgress';

const ProtectedRoute = ({ children, requiredRole }) => {
  const [authStatus, setAuthStatus] = useState({ isAuthenticated: null, role: null });

  useEffect(() => {
    const verifyAuth = async () => {
      const auth = await checkAuth();
      setAuthStatus(auth);
    };

    verifyAuth();
  }, []);

  if (authStatus.isAuthenticated === null) {
    return <CircularProgress />;
  }

  if (!authStatus.isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requiredRole && authStatus.role !== requiredRole) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default ProtectedRoute;